<div *ngIf="PartialViewReady">
    <h2 class="mat-title">Change the active student below:</h2>
    <mat-table class="bordered" #table [dataSource]="StudentChildrenData">
        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let student" class="centered">
                <button mat-raised-button color="primary" *ngIf="StudentChildren && StudentChildren.length > 1 && SelectedStudent && SelectedStudent.StudentID != student.StudentID" (click)="SetActiveStudent(student)">Select</button>
                <div *ngIf="SelectedStudent && SelectedStudent.StudentID == student.StudentID">Selected</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="StudentID">
            <mat-header-cell *matHeaderCellDef class="centered">Student ID</mat-header-cell>
            <mat-cell *matCellDef="let student" class="centered">{{student.StudentID}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="LastName">
            <mat-header-cell *matHeaderCellDef class="centered">Last Name</mat-header-cell>
            <mat-cell *matCellDef="let student" class="centered">{{student.LastName | titleCase}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="FirstName">
            <mat-header-cell *matHeaderCellDef class="centered">First Name</mat-header-cell>
            <mat-cell *matCellDef="let student" class="centered">{{student.FirstName | titleCase}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="MiddleName">
            <mat-header-cell *matHeaderCellDef class="centered">Middle Name</mat-header-cell>
            <mat-cell *matCellDef="let student" class="centered">{{student.MiddleName | titleCase}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="School">
            <mat-header-cell *matHeaderCellDef class="centered">School</mat-header-cell>
            <mat-cell *matCellDef="let student" class="centered">{{student.SchoolName}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Grade">
            <mat-header-cell *matHeaderCellDef class="centered">Grade</mat-header-cell>
            <mat-cell *matCellDef="let student" class="centered">{{student.GradeLevel}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let student">
                <em>No registered students were found in your DELTA account. Please contact your child's school counselor for more information on how to register your son/daughter in the DELTA System.</em>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">Student(s)</mat-header-cell>
            <mat-cell *matCellDef="let student">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="center center" class="padtop">
                        <button mat-raised-button color="primary" *ngIf="StudentChildren && StudentChildren.length > 1 && SelectedStudent && SelectedStudent.StudentID != student.StudentID" (click)="SetActiveStudent(student)">Select</button>
                        <div *ngIf="SelectedStudent && SelectedStudent.StudentID == student.StudentID">Selected</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Student ID</form-label>
                        <div>{{student.StudentID}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Last Name</form-label>
                        <div>{{student.LastName | titleCase}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>First Name</form-label>
                        <div>{{student.FirstName | titleCase}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Middle Name</form-label>
                        <div>{{student.MiddleName | titleCase}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>School</form-label>
                        <div fxLayout="column" fxLayoutAlign="start end">
                            <div>{{student.SchoolName}}</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Grade</form-label>
                        <div>{{student.GradeLevel}}</div>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: VisibleColumns; let $odd = odd" [class.primarybackground50]="$odd" [class.selectedstudent]="SelectedStudent && row.StudentID == SelectedStudent.StudentID"></mat-row>
    </mat-table>
</div>


// WEBPACK FOOTER //
// ./src/app/studentselect/studentselect.component.html